<template>
    <el-row :gutter="20">
        <el-col :span="info.span ? info.span : 6" v-for="info in searchs" :key="info.model"
                :class="{ 'flex-end': info.type === 'button' }">

            <el-form-item style="display: flex" :label="info.type === 'button' ? '' : `${info.label}： `" :prop="info.model" :label-width="info.labelWidth ? info.labelWidth : ''">
                <!-- Text Input -->
                <el-input v-if="info.type === 'text'" v-model="formData[info.model]" v-bind="info.props" clearable/>

                <!-- doubleText Input -->
                <div v-if="info.type === 'doubleText'" class="flexBox">
                    <el-input  v-model.number="formData[info.model[0]]" v-bind="info.props" clearable/>-
                    <el-input  v-model.number="formData[info.model[1]]" v-bind="info.props" clearable/>
                </div>

                <!-- Select -->
                <el-select v-else-if="info.type === 'select'" v-model="formData[info.model]" :loading="info.loading" clearable
                           v-bind="info.props" @change="info.props.Fun?info.props.Fun($event):''" type="large" style="width: 100%">
                    <el-option v-for="option in info.options" :key="info.props.optionValue ? option[info.props.optionValue] : option.value"
                               :label="info.props.optionLabel ? option[info.props.optionLabel] : option.label"
                               :value="info.props.optionValue ? option[info.props.optionValue] : option.value" />
                </el-select>

                <!-- cascader -->
                <el-cascader v-else-if="info.type === 'cascader'" v-model="formData[info.model]" :options="info.options" :loading="info.loading" clearable
                             v-bind="info.props" @change="info.props.Fun">
                </el-cascader>

                <!-- Radio -->
                <el-radio-group v-else-if="info.type === 'radio'" v-model="formData[info.model]" >
                    <div class="flexBox">
                        <el-radio v-for="option in info.options" :key="option.value" :label="option.value" :value="option.value">{{
                                option.label
                            }}</el-radio>
                    </div>

                </el-radio-group>

                <!-- DatePicker -->
                <el-date-picker v-else-if="info.type === 'date'" v-model="formData[info.model]" :type="info.props.type" clearable
                                range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间" size="large" unlink-panels v-bind="info.props" />

                <!-- Checkbox -->
                <el-checkbox-group v-else-if="info.type === 'checkbox'" v-model="formData[info.model]">
                    <el-checkbox v-for="option in info.options" :key="option.value" :label="option.value">{{
                            option.label
                        }}</el-checkbox>
                </el-checkbox-group>

                <!-- 按钮模块 -->
                <template v-if="info.type === 'button'">
                    <div class="flex-box">
                        <el-button v-for="btn_info in info.buttonList" :key="btn_info.label" v-bind="btn_info.props"
                                   @click="handleClick(btn_info.state)">{{ btn_info.label }}</el-button>
                    </div>
                </template>
            </el-form-item>
        </el-col>
    </el-row>
</template>

<script>
export default {
    props: {
        searchs: {
            type: Array,
            default: () => []
        },
        formData: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        // 搜索重置按钮处理
        handleClick(btnName) {
            this.$emit('search', btnName, this.formData);
        }
    }
};
</script>

<style scoped lang="less">
.flexBox{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
/deep/.el-form-item__content{
    margin-left: 0 !important;
}
.flex-box{
    width: 100%;
    display: flex;
    justify-content: flex-end !important;
}
</style>



// WEBPACK FOOTER //
// src/Hcomponents/HsearchModel/formItem.vue